var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.756 6.46634L2.41549 11.8068C2.15792 12.0644 1.74034 12.0644 1.4828 11.8068L0.859917 11.1839C0.60279 10.9268 0.602295 10.5101 0.858818 10.2524L5.09126 5.99999L0.858818 1.74765C0.602295 1.48991 0.60279 1.07318 0.859917 0.816057L1.4828 0.193175C1.74037 -0.0643917 2.15795 -0.0643917 2.41549 0.193175L7.75597 5.53366C8.01354 5.7912 8.01354 6.20878 7.756 6.46634Z",
    fill: "#AEA5E4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRightArrow);
export default __webpack_public_path__ + "static/media/NavRightArrow.c6dca25ed9b4d14334eab6194172cbe2.svg";
export { ForwardRef as ReactComponent };